import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Privacy from "../components/Privacy";

export default withRouter(connect()(Privacy));
